import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from './store'
import router from './router'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import 'text-spinners'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/animate.css'
import './assets/fonts/fonts.css'
// import Slick from 'vue-slick'
import '../node_modules/slick-carousel/slick/slick.css'
import VueApexCharts from 'vue-apexcharts'
import { firestorePlugin } from 'vuefire'
// import fireApp from '@/helpers/_firebase'
// import ApexCharts from 'apexcharts'

Vue.config.productionTip = false
moment.locale('es')
Vue.use(Vue2Filters)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueApexCharts)
Vue.use(firestorePlugin)
// Vue.use(ApexCharts)
// Vue.use(Slick)
Vue.filter('moment', function (date) {
  return moment(date).format('lll')
})
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
